import { useMemo } from "react";
import { timeElapsedSinceBirth } from "./util.ts";
import { PAGE_PATHS } from "./config.ts";
import { HappyTailListItem } from "./types.ts";
import noDogPhoto from "./assets/images/dog_placeholder.jpg";
import noCatPhoto from "./assets/images/cat_placeholder.jpg";
import noBunnyPhoto from "./assets/images/bunny_placeholder.jpg";

type PetPreviewProps = {
  item: HappyTailListItem;
};

export function AdoptedPetPreview({ item }: PetPreviewProps) {
  const age = useMemo(() => {
    const { years, months } = timeElapsedSinceBirth(item.dateOfBirth);
    const parts: string[] = [];
    if (years > 0) parts.push(`${years} years`);
    if (months > 0) parts.push(`${months} months`);
    return parts.join(", ");
  }, [item.dateOfBirth]);

  // Determine a safe photo for pets without valid photos
  const safePetPhoto = /[A-Za-z0-9]/.test(item.photo)
    ? item.photo
    : {
        dog: noDogPhoto,
        cat: noCatPhoto,
        bunny: noBunnyPhoto,
      }[item.species?.toLowerCase()] || noDogPhoto; // Fallback to noDogPhoto

  // const photoUrl = item.photo ? item.photo : {noPhotoAvailable};
  const petUrl = `${PAGE_PATHS.PET_DETAIL}?adoption=${item.adoptionId}`;

  const petGender = item.sex === "M" ? "male" : "female";

  return (
    <div className="flex flex-col w-full sm:max-w-sm !bg-white rounded overflow-hidden shadow-md">
      <div
        className="relative w-full aspect-[3/4]"
        style={{
          backgroundImage: `url(${safePetPhoto})`,
          backgroundSize: "cover",
          backgroundPosition: "50% 20%",
        }}
      ></div>
      <div className="px-4 py-4">
        <div
          className="text-2xl font-bold text-[#ef3825] mb-4"
          style={{ fontFamily: "Varela Round", fontSize: "25.5px" }}
        >
          <a
            href={petUrl}
            className="text-2xl font-bold text-[#ef3825] cursor-pointer"
          >
            {item.name}
          </a>
        </div>
        <div className="mb-2">
          <strong>Age / Gender</strong> {age} / {petGender}
        </div>
        {/* <div className='mb-2'><strong>Looks Like</strong>{' '}{item.breed}</div> */}
        {/* <div className='mb-2'><strong>Location</strong>{' '}{item.location}</div> */}
      </div>
      <div className="mt-auto w-full text-center">
        <a
          className={
            "capitalize bg-primary p-4 hover:bg-primary-hover focus:!bg-primary text-[18px] hover:!text-[18px] text-md !text-on-primary visited:text-on-primary w-full inline-block"
          }
          style={{ color: "white", textDecoration: "none", fontWeight: "600" }} //DML: unfotunate hack necessary to over-ride WP site styles
          href={petUrl}
        >
          Meet {item.name}
        </a>
      </div>
    </div>
  );
}
